<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.table && localService.languageContent.printer">
    <div style="max-width: 500px;" class="center">
        <div class="row" style="margin-bottom: 10px;">
            <div class="col-12">
                <button class="btn btn-primary" (click)="onAction(2)" style="float: right;" [disabled]="!itemsList">
                    <i class="material-icons" style="color: white;top: 5px;position: relative;">save</i>
                    <span>{{localService.languageContent.common.save}}</span>
                </button>
            </div>
        </div>
        <div class="row" *ngIf="itemsList">
            <div class="col-12">
                <div class="banner">
                    <div class="row styled_row" *ngFor="let item of itemsList">
                        <div class="col-12">
                            <label style="margin-left:20px;font-weight:normal;" title="{{item.value}}" [ngStyle]="{'opacity' : item.isInActive ? '0.5' : '1'}">
                                <input type="checkbox" [(ngModel)]="item.isSelected">
                                <span style="color:darkslategrey">&nbsp;{{item.value}}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>